export default __webpack_public_path__ + "static/media/facebook.e8cd5f90.svg";